<template>
  <v-layout full-height>
    <AppNavigationDrawer v-model="drawer" :mobile="smAndDown">
      <template #title-text>
        <v-btn
          class="px-0"
          variant="plain"
          :to="{ name: '/[[space]]/kb/' }"
          style="font-size: inherit"
        >
          {{ t('knowledge-base') }}
        </v-btn>
      </template>
      <template #title-append>
        <KbCreateButton />
      </template>
      <template #toolbar-append>
        <v-text-field
          v-model="search"
          :placeholder="t('search')"
          hide-details
          class="mx-2 mt-3 mb-2"
          clearable
        />
      </template>

      <KbTreeView :search class="overflow-auto pt-0 px-1" />
    </AppNavigationDrawer>

    <v-main tag="div" class="transition-none" scrollable>
      <AppNavigationDrawerExpandButton
        v-if="smAndDown"
        v-model="drawer"
        class="ml-1 mt-1 mb-0"
      />
      <RouterView />
    </v-main>
  </v-layout>
</template>

<script setup lang="ts">
import AppNavigationDrawer from '@/components/common/AppNavigationDrawer.vue'
import AppNavigationDrawerExpandButton from '@/components/common/AppNavigationDrawerExpandButton.vue'
import KbCreateButton from '@/components/kb/KbCreateButton.vue'
import KbTreeView from '@/components/kb/KbTreeView.vue'
import '@/styles/md.scss'
import '@/styles/ckeditor.scss'
import { useDisplay } from 'vuetify'

definePage({
  meta: { feature: 'kb' },
})

const drawer = ref(false)

const { smAndDown } = useDisplay()

const { t } = useI18n()
const search = ref()
</script>
